var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-1 inner"},[_c('div',{staticClass:"text-1-text ecc",domProps:{"innerHTML":_vm._s(_vm.item.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }